export default __webpack_public_path__ + "static/media/logo-SANTELYS.8718dd82.png";